import React from 'react';
import { Table, TableProps } from 'antd';
import COAlertModal from '../COAlertModal';

export interface COTableProps<T> extends TableProps<T> {
  columns: any;
  showEditModalState?: boolean;
  showDeleteModalState?: boolean;
  handleDeleteModalStateConfirm?: (value: boolean) => void;
  handleDeleteModalStateCancel?: (value: boolean) => void;
  handleRowClick?: (record: any) => void;
  handleEditModalStateConfirm?: (value: boolean) => void;
  handleEditModalStateCancel?: (value: boolean) => void;
  data: any;
  headingDelete?: string;
  subheadingDelete?: string;
  headingEdit?: string;
  subheadingEdit?: string;
  loading?: boolean;
  editModal?: React.ReactNode;
  rowKey?: string;
}

const COTable = <T extends object>({
  columns,
  handleRowClick,
  handleDeleteModalStateConfirm,
  handleDeleteModalStateCancel,
  showDeleteModalState = false,
  data,
  loading,
  headingDelete,
  subheadingDelete,
  editModal,
  rowKey,
  ...remainingProps
}: COTableProps<T>) => {
  const handleModalCancel = () => {
    handleDeleteModalStateCancel?.(false);
  };
  const handleModalConfirm = () => {
    handleDeleteModalStateConfirm?.(false);
  };
  const handleOnRowEvents = (record: T) => ({
    onClick: () => handleRowClick?.(record),
  });
  return (
    <>
      {editModal}
      <COAlertModal
        handleModalCancel={handleModalCancel}
        handleModalConfirm={handleModalConfirm}
        showModalState={showDeleteModalState}
        deleteModal
        heading={headingDelete}
        subHeading={subheadingDelete}
      />
      <Table<T>
        rowKey={rowKey ?? 'id'}
        loading={loading}
        columns={columns}
        pagination={false}
        dataSource={data}
        onRow={handleOnRowEvents}
        {...remainingProps}
      />
    </>
  );
};

export default COTable;
